// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__RWMaN","title":"Header_title__F61jI","side":"Header_side__29YAQ"};